import * as React from 'react';
import { Route, Redirect, Switch, HashRouter } from 'react-router-dom';

import Portal from 'src/portals/Portal';
import SignInView from 'src/pages/SignInView';
import SearchResultsView from 'src/pages/SearchResultsView';
import EmailSubscription from 'src/components/EmailSubscription';
import ListsView from 'src/pages/ListsView';
import ModelView from 'src/pages/Model';
import Categories from 'src/pages/Categories';
import CartView from 'src/pages/CartView';
import CheckoutView from 'src/pages/CheckoutView';
import PartView from 'src/pages/PartView';
import OrdersView from 'src/pages/OrdersView';
import InvoiceView from 'src/pages/InvoiceView';
import BillingAddressView from 'src/pages/BillingAddressView';
import PartClaimView from '../PartClaimView';
import WarrantyClaim from '../WarrantyClaim';
import DashboardView from 'src/pages/DashboardView';
import TrackingView from 'src/pages/TrackingInfoView';
import SamsungOrderInvoiceView from 'src/pages/SamsungOrderInvoiceView';

import Header from 'src/components/Header';
import HeaderBanner from 'src/components/HeaderBanner';
import AccountSwitchPage from 'src/pages/AccountSwitchPage';
import Menu from 'src/components/Menu';
import DashboardMenu from 'src/components/DashboardMenu';
import MenuForSamsungInvoiceView from 'src/components/SamsungOrderInvoiceSearchFormTable/MenuForSamsungInvoiceView';

import {
  goToSearch,
  ifLoggedIn,
  goToPartDetail,
  goToModelDetail
} from 'src/utils/navigation';
import PrivateRoute from 'src/utils/privateRoute';
import SpecialUserPrivateRoute from 'src/utils/specialUserPrivateRoute';
import OpenRoute from 'src/utils/openRoute';
import store from 'src/store';
import { isLoggedInSel, samsungUserSel } from 'src/store/modules/signin';
import { accountSpecialUserSel, accountIdSel } from 'src/store/modules/user';

import './Content.scss';
import RegisterView from '../RegisterView';
import FeedbackView from '../FeedbackView';
import AccountView from '../AccountView';
import ForgotPasswordView from '../ForgotPasswordView';
import RedirectToSignin from '../RedirectToSignIn';
import { VerifyPasswordView } from '../VerifyPasswordView/VerifyPasswordView';
import ForgotUserIdView from '../ForgotUserIdView';
import ReturnsView from '../ReturnsView';
import MyTopProducts from 'src/components/MyTopProducts';
import FrequentlyPurchasedProducts from 'src/components/FrequentlyPurchasedProducts';
import BrowsingHistoryProducts from 'src/components/BrowsingHistoryProducts';
import ScrollButton from 'src/components/ScrollButton';
import InvoiceRoute from 'src/components/Invoices/components/InvoiceRoute/InvoiceRoute';
import FlyersUs from 'src/components/Flyers/FlyersUs';
import FlyersCa from 'src/components/FlyersCa/FlyersCa';
import WarrantyView from '../WarrantyView/WarrantyView';
import DamagedView from '../DamagedView/DamagedView';
import DifferentissueView from '../DifferentissueView/DifferentissueView';
import PromosUs from 'src/components/Promos/PromosUs';
import PromosCa from 'src/components/PromosCa/PromosCa';
import SynonymManager from '../SynonymManager/SynonymManager';
import PartSmartView from '../PartSmartView/PartSmartView';

export class Content extends React.Component<{}, {}> {
  private onSubmitSearch = (text: string) => {
    ifLoggedIn(() => goToSearch(text));
  };

  private onSearchSelectedPart = (text: string) => {
    ifLoggedIn(() => goToPartDetail(text));
  };

  private onSearchSelectedModel = (name: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(name, manufacturer));
  };

  public render() {
    const state = store.getState();
    const isSamsungUser = localStorage.getItem('isSamsungUser');
    return (
      <HashRouter>
        <div>
          {(!accountSpecialUserSel(state) ||
            accountIdSel(state) !== accountSpecialUserSel(state)) &&
          !isSamsungUser ? (
            <div>
              <Portal idElementToRender={'specialuserbanner'}>
                <HeaderBanner />
              </Portal>
              <Portal idElementToRender={'header'}>
                <Menu
                  content={true}
                  handleOnSubmitSearch={this.onSubmitSearch}
                  handleOnSearchSelectedPart={this.onSearchSelectedPart}
                  handleOnSearchSelectedModel={this.onSearchSelectedModel}
                />
                <FeedbackView />
              </Portal>
              <Portal idElementToRender={'searchbar'}>
                <Switch>
                  <Route
                    exact={true}
                    path="/search/:text?"
                    render={() => (
                      <Header
                        handleOnSubmitSearch={this.onSubmitSearch}
                        handleOnSearchSelectedPart={this.onSearchSelectedPart}
                        handleOnSearchSelectedModel={this.onSearchSelectedModel}
                        shouldShowSearchDropdown={false}
                      />
                    )}
                  />
                  <Route
                    render={() => (
                      <Header
                        handleOnSubmitSearch={this.onSubmitSearch}
                        handleOnSearchSelectedPart={this.onSearchSelectedPart}
                        handleOnSearchSelectedModel={this.onSearchSelectedModel}
                        shouldShowSearchDropdown={true}
                      />
                    )}
                  />
                </Switch>
              </Portal>
              <Portal idElementToRender={'scrollButton'}>
                <ScrollButton />
              </Portal>
            </div>
          ) : isSamsungUser ? (
            <div>
              <Portal idElementToRender={'specialuserbanner'}>
                <HeaderBanner />
              </Portal>
              <Portal idElementToRender={'header'}>
                <MenuForSamsungInvoiceView
                  content={true}
                  handleOnSubmitSearch={this.onSubmitSearch}
                  handleOnSearchSelectedPart={this.onSearchSelectedPart}
                  handleOnSearchSelectedModel={this.onSearchSelectedModel}
                />
                <FeedbackView />
              </Portal>
              <Portal idElementToRender={'scrollButton'}>
                <ScrollButton />
              </Portal>
            </div>
          ) : (
            <div>
              <Portal idElementToRender={'header'}>
                <DashboardMenu />
              </Portal>
            </div>
          )}
          <div className="rp-app-container">
            <Switch>
              <Route exact={true} path="/login" component={SignInView} />
              <OpenRoute
                exact={true}
                path="/register"
                component={RegisterView}
              />
              <OpenRoute
                exact={true}
                path="/forgot"
                component={ForgotPasswordView}
              />
              <OpenRoute
                exact={true}
                path="/forgotuser"
                component={ForgotUserIdView}
              />
              <PrivateRoute
                exact={true}
                path="/verify"
                component={VerifyPasswordView}
              />
              <PrivateRoute
                exact={true}
                path="/switchaccount"
                component={AccountSwitchPage}
              />
              <PrivateRoute
                exact={true}
                path="/search/:text?"
                component={SearchResultsView}
              />
              {/* <PrivateRoute
                exact={true}
                path="/emailsubscribe"
                component={EmailSubscription}
              /> */}
              <PrivateRoute exact={true} path="/lists" component={ListsView} />
              <OpenRoute
                exact={true}
                path="/part/:partNumber?"
                component={PartView}
              />
              <OpenRoute
                exact={true}
                path="/categories/:categoryId/:subcategoryId"
                component={Categories}
              />
              <OpenRoute
                exact={true}
                path="/model/:modelId/:manufacturer?"
                component={ModelView}
              />
              <PrivateRoute exact={true} path="/cart" component={CartView} />
              <PrivateRoute
                exact={true}
                path="/checkout"
                component={CheckoutView}
              />
              <PrivateRoute
                exact={true}
                path="/orders/:orderNumber?"
                component={OrdersView}
              />

              <PrivateRoute path="/invoices" component={InvoiceRoute} />
              <PrivateRoute
                exact={true}
                path="/flyers-us/center"
                component={FlyersUs}
              />
              <PrivateRoute
                exact={true}
                path="/flyers-us/right"
                component={FlyersUs}
              />
              <PrivateRoute
                exact={true}
                path="/flyers-us/left"
                component={FlyersUs}
              />
              <PrivateRoute
                exact={true}
                path="/flyers-ca/center"
                component={FlyersCa}
              />
              <PrivateRoute
                exact={true}
                path="/flyers-ca/left"
                component={FlyersCa}
              />
              <PrivateRoute
                exact={true}
                path="/flyers-ca/right"
                component={FlyersCa}
              />
              <PrivateRoute
                exact={true}
                path="/promos-us/center"
                component={PromosUs}
              />
              <PrivateRoute
                exact={true}
                path="/promos-ca/center"
                component={PromosCa}
              />
              <PrivateRoute
                exact={true}
                path="/tracking"
                component={TrackingView}
              />
              <PrivateRoute
                exact={true}
                path="/returns"
                component={ReturnsView}
              />
              <PrivateRoute
                exact={true}
                path="/warranty"
                component={WarrantyView}
              />
              <OpenRoute
                exact={true}
                path="/solr/synonymmanager"
                component={SynonymManager}
              />
              {/* <PrivateRoute
                exact={true}
                path="/damaged"
                component={DamagedView}
              /> */}
              {/* <PrivateRoute
                exact={true}
                path="/differentissueview"
                component={DifferentissueView}
              /> */}
              <PrivateRoute
                exact={true}
                path="/account/billingAddress"
                component={BillingAddressView}
              />
              <PrivateRoute path="/account" component={AccountView} />
              <SpecialUserPrivateRoute
                exact={true}
                path="/dashboard"
                component={DashboardView}
              />
              <PrivateRoute
                exact={true}
                path="/Retail"
                component={PartClaimView}
              />
              {/* <PrivateRoute
                exact={true}
                path="/warrantyclaim"
                component={WarrantyClaim}
              /> */}
              <PrivateRoute
                exact={true}
                path="/products"
                component={MyTopProducts}
              />
              <PrivateRoute
                exact={true}
                path="/frequently-purchased-products"
                component={FrequentlyPurchasedProducts}
              />
              <PrivateRoute
                exact={true}
                path="/browsing-history-products"
                component={BrowsingHistoryProducts}
              />
              <PrivateRoute
                exact={true}
                path="/samsung-portal-invoice"
                component={SamsungOrderInvoiceView}
              />
              <OpenRoute
                exact={true}
                path="/redirect"
                component={RedirectToSignin}
              />
              <PrivateRoute
                exact={true}
                path="/partsmart"
                component={PartSmartView}
              />
              <Route render={() => <Redirect push={false} to="/login" />} />
            </Switch>
          </div>
        </div>
      </HashRouter>
    );
  }
}
